import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { X } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.19, 1, 0.22, 1] }}
        className="max-w-lg w-full text-center"
        data-testid="payment-cancel-page"
      >
        <div className="w-16 h-16 mx-auto border border-aak-border flex items-center justify-center mb-8">
          <X className="w-7 h-7 text-aak-mutedfg" strokeWidth={1.4} />
        </div>
        <p className="text-xs uppercase tracking-[0.3em] text-aak-primary mb-5">Checkout Cancelled</p>
        <h1 className="font-serif font-light text-5xl md:text-6xl tracking-tighter text-aak-fg mb-4">
          No worries.
        </h1>
        <p className="text-sm text-aak-mutedfg mb-8">
          Your bag has been saved. Take your time — the collection will be waiting.
        </p>
        <button
          data-testid="back-home-btn"
          onClick={() => navigate("/")}
          className="bg-aak-fg text-aak-bg px-8 py-4 text-xs uppercase tracking-[0.25em] hover:bg-aak-primary transition-colors duration-500"
        >
          Return to AAK
        </button>
      </motion.div>
    </div>
  );
}
